/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useContext, useEffect, useState } from "react";
import { useAuthentication } from "./Authentication";
import { buscarEstablecimiento } from "../api/Establecimiento";
import { listarTramites } from "../api/Tramite";
import Loader from "../components/controls/Loader";

const EstablecimientoContext = createContext(null);

export function useEstablecimiento() {
  const context = useContext(EstablecimientoContext);
  if (!context) {
    throw new Error(
      "useEstablecimiento debe ser usado dentro de un EstablecimientoProvider",
    );
  }
  return context;
}

export function EstablecimientoProvider({ children, ...props }) {
  const { token, loadUserProfile } = useAuthentication();
  const [establecimiento, setEstablecimiento] = useState();
  const [tramites, setTramites] = useState();
  const [update, setUpdate] = useState(true);
  const [loading, setLoading] = useState(true);
  const refresh = () => {
    setUpdate(true);
  };
  useEffect(() => {
    const actualizarEstablecimiento = async () => {
      const profile = await loadUserProfile();
      try {
        const establecimiento = await buscarEstablecimiento(
          profile.username,
          token,
        );
        const tramites = await listarTramites(
          { CURT: establecimiento.CURT },
          token,
        );
        setEstablecimiento(establecimiento);
        setTramites(tramites);
      } catch (error) {
        console.debug("El establecimiento no esta dado de alta en REAMAR");
        setEstablecimiento({ CURT: profile.username, estaEmpadronado: false });
        setTramites([]);
      } finally {
        setLoading(false);
      }
    };
    if (update) {
      setLoading(true);
      actualizarEstablecimiento();
    }
  }, [update]);
  return (
    <EstablecimientoContext.Provider
      value={{ establecimiento, tramites, refresh }}
    >
      <Loader loading={loading}>{children}</Loader>
    </EstablecimientoContext.Provider>
  );
}
